import React from 'react';
import { ApiUrl, UserRoles } from '../../../project/Defines.js';
import ListView from '../../../Shared/ListView';
import { COLUMN_FORMAT, COLUMN_TYPE } from '../../../Shared/ListView/helper';
import { EVENT_NAME } from '../../../project/utilities';
import { connect } from 'react-redux';
import { DatePicker } from '~/Shared/DatePicker/index.js';

/**
 * the Product list of SparePart in SalesNetwork tab
 * @exports SparePart-SalesNetwork
 */
function SparePartSalesNetwork(props) {
    const isSuperAdmin = props.role === UserRoles.SUPERADMIN;
    const isAdmin = props.role === UserRoles.ADMIN;
    const columnConfig = [

        {
            text: 'text.sales_network',
            field: 'reseau_nom',
            width: 300,
            type: COLUMN_TYPE.TEXT,
            readOnly: true,
        },
        {
            text: 'text.status',
            field: 'statut',
            width: 150,
            type: COLUMN_TYPE.TEXT,
            readOnly: !isSuperAdmin,
        },
        {
            text: 'text.replacement',
            // noSort: true,
            field: 'is_replaced_by',
            width: 280,
            type: COLUMN_TYPE.TEXT,
            readOnly: true,
        },
        {
            text: 'text.stock',
           // noSort: true,
            field: 'stock',
            width: 120,
            type: COLUMN_TYPE.TEXT,
            format: COLUMN_FORMAT.NUMBER,
            readOnly: !isSuperAdmin,
        },
        {
            text: 'text.commentaire',
           // noSort: true,
            field: 'commentaire',
            //width: 280,
            type: COLUMN_TYPE.TEXT,
            readOnly: !isSuperAdmin && !isAdmin,
        },
        {
            text: 'text.deleted_at',
            field: 'deleted_at',
            width: 180,
            format: COLUMN_FORMAT.DATETIME,
            type: COLUMN_TYPE.TEXT,
            readOnly: !isSuperAdmin,
            editor: {
                customRenderer: (props) => { // NOSONAR
                    const { editingRecord, setEditingRecord, record } = props;
                    return (
                        <DatePicker dataField="deleted_at" dataItem={record} showTime={true}
                            setDataItem={(item)=>{
                                setEditingRecord({
                                    ...editingRecord, deleted_at: item.deleted_at
                                });
                            }}
                            className={'ant-input'} />
                    )
                }
            }
        },
        isSuperAdmin || isAdmin ? {
            //fixed: "right",
            type: COLUMN_TYPE.ACTION
        } : null,
    ];

    return (<>
        <ListView
            search={{ field: 'search' }}
            isSimple
            editable
            {...props}
            skipNewButton
            noPaging
            tableLayout="Fixed"
            staticFilter={{ article_uuid: props.ID }}
            columnConfig={columnConfig}
            apiUrl={ApiUrl.ArticleSalesNetworkList}
            inlineUpdateUrl={ApiUrl.ArticleSalesNetworkUpdate}
            listUpdateEvent={EVENT_NAME.ARTICLE_SALES_NETWORK_LIST_UPDATE}
        />
    </>);
}

export default connect(state => ({ role: state.role }))(SparePartSalesNetwork);